import moment from "moment";
import Flowit from "../../../services/flowit";
import * as types from "./types";
import { mutations, state } from "./mutations";

// eslint-disable-next-line no-unused-vars

export const loadList = ({ commit }) => {
  Flowit.invoices.getList().then(response => {
    commit(types.LIST, response.data.list);
    commit(types.RESOURCES, response.data.list);
    commit(types.SUBTOTAL, response.data.subtotal);
    commit(types.RESOURCES_COUNT, response.data.count);
    commit(types.LOADING_DATA, false);
  });
};

export const load = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  Flowit.invoices.list(params).then(response => {
    commit(types.LIST, response.data.list);
    commit(types.RESOURCES, response.data.resources);
    commit(types.SUBTOTAL, response.data.subtotal);
    commit(types.RESOURCES_COUNT, response.data.count);
    commit(types.LOADING_DATA, false);
  });
};

export const showFilters = ({ commit }) => {
  commit(types.FILTER_VISIBLE, true);
};

export const hideFilters = ({ commit }) => {
  commit(types.FILTER_VISIBLE, false);
};

export const resetFilters = ({ commit }) => {
  commit(types.ORDINATION, null);
  commit(types.FILTER_STATUS, null);
  commit(
    types.FILTER_INITIAL_DATE,
    moment()
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.FILTER_FINAL_DATE,
    moment()
      .endOf("month")
      .format("YYYY-MM-DD")
  );
};

export const exportExtract = ({ commit }, params) => {
  Flowit.invoices.exportExtract(params).then(response => {});
};

// eslint-disable-next-line no-unused-vars
export const get = ({ commit }, invoiceId) => {
  commit(types.LOADING_DATA, true);
  return Flowit.invoices.get(invoiceId).then(response => {
    commit(types.SET_INVOICE_DATA, response.data);
    commit(types.LOADING_DATA, false);
    return response;
  }).catch(error => {
    commit(types.LOADING_DATA, false);
    console.error('Erro ao carregar invoice:', error);
    throw error;
  });
};

export const updateInitialDate = ({ commit }, newDate) => {
  commit(types.FILTER_INITIAL_DATE, newDate);
};

export const updateFinalDate = ({ commit }, newDate) => {
  commit(types.FILTER_FINAL_DATE, newDate);
};

export const updateStatus = ({ commit }, newStatus) => {
  commit(types.FILTER_STATUS, newStatus);
};

export const updateLimit = ({ commit }, newLimit) => {
  commit(types.LIMIT, newLimit);
};

export const updateCurrentPage = ({ commit }, newCurrentPage) => {
  commit(types.CURRENT_PAGE, newCurrentPage);
};

export const updateOrdination = ({ commit }, newOrdination) => {
  commit(types.ORDINATION, newOrdination);
};

export const setLimit = ({ commit }, limit) => {
  commit(types.LIMIT, limit);
};

export const setCurrentPage = ({ commit }, page) => {
  commit(types.CURRENT_PAGE, page);
};

export const getLink = ({ commit, dispatch, getters }, params) => {
  commit(types.LOADING_DATA, true);
  return Flowit.invoices.getLink(params).then(
    response => {
      commit(types.LINK, response.data.link);
      commit(types.NEW_LINK_STATUS, true);
      commit(types.NEW_LINK_ERROR, false);
      commit(types.LOADING_DATA, false);
      
      // Recarregar a lista automaticamente após criar o link
      setTimeout(() => {
        dispatch('load', getters.filter);
      }, 500);
      
      return response;
    },
    error => {
      commit(types.LINK, error.response.data);
      commit(types.NEW_LINK_ERROR, true);
      commit(types.NEW_LINK_STATUS, false);
      commit(types.LOADING_DATA, false);
      throw error;
    }
  );
};

export const link = ({ commit }, params) => {
  Flowit.invoices.getLink(params).then(response => {
    commit(types.LINK, response.data.link);
  });
};

export const loadSubscriptions = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  Flowit.invoices.listSubscriptions(params).then(response => {
    commit(types.SET_SUBSCRIPTIONS_RESOURCES, response.data.resources);
    commit(types.SET_SUBSCRIPTIONS_RESOURCES_COUNT, response.data.count);
    commit(types.SET_SUBSCRIPTIONS_LOADING_DATA, false);
  }).catch(error => {
    console.warn('Subscriptions API endpoint not available:', error.message);
    commit(types.SET_SUBSCRIPTIONS_RESOURCES, []);
    commit(types.SET_SUBSCRIPTIONS_RESOURCES_COUNT, 0);
    commit(types.SET_SUBSCRIPTIONS_LOADING_DATA, false);
  });
};

export const setSubscriptionsCurrentPage = ({ commit }, page) => {
  commit(types.SET_SUBSCRIPTIONS_CURRENT_PAGE, page);
};

export const setSubscriptionsLimit = ({ commit }, limit) => {
  commit(types.SET_SUBSCRIPTIONS_LIMIT, limit);
};

export const cancelSubscription = ({ commit }, id) => {
  Flowit.invoices
    .cancelSubscription(id)
    .then(response => {})
    .catch(error => {});
};

export const subscription = ({ commit }, id) => {
  commit(types.LOADING_DATA, true);
  commit(types.SUBSCRIPTION_SET, false);
  Flowit.invoices
    .subscription(id)
    .then(response => {
      commit(types.SUBSCRIPTION, response.data.subscription);
      commit(types.SUBSCRIPTION_SET, true);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {});
};

// Eletronic Payments
export const loadEletronicPayments = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  Flowit.invoices.listEletronicPayments(params).then(response => {
    commit(types.SET_ELETRONIC_PAYMENTS_RESOURCES, response.data.deposits);
    commit(types.SET_ELETRONIC_PAYMENTS_RESOURCES_COUNT, response.data.count);
    commit(types.SET_ELETRONIC_PAYMENTS_LOADING_DATA, false);
  });
};

export const setEletronicPaymentsCurrentPage = ({ commit }, page) => {
  commit(types.SET_ELETRONIC_PAYMENTS_CURRENT_PAGE, page);
};

export const setEletronicPaymentsLimit = ({ commit }, limit) => {
  commit(types.SET_ELETRONIC_PAYMENTS_LIMIT, limit);
};

export const cancelEletronicPayment = ({ commit }, id) => {
  Flowit.invoices
    .cancelEletronicPayment(id)
    .then(response => {})
    .catch(error => {});
};

export const eletronicPayment = ({ commit }, id) => {
  Flowit.invoices
    .eletronicPayment(id)
    .then(response => {
      commit(types.ELETRONIC_PAYMENT, response.data.deposit);
    })
    .catch(error => {});
};

export const newEletronicPayment = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  commit(types.NEW_INVOICE_STATUS, false);
  commit(types.INVOICE_ERROR_STATUS, false);
  Flowit.invoices
    .newEletronicPayment(params)
    .then(response => {
      commit(types.NEW_ELETRONIC_PAYMENT, response.data.deposit);
      commit(types.NEW_INVOICE_STATUS, true);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {
      commit(types.INVOICE_ERROR_STATUS, true);
      commit(types.INVOICE_ERROR_MESSAGE, error);
      commit(types.LOADING_DATA, false);
    });
};

export const location = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  commit(types.NEW_INVOICE_STATUS, false);
  commit(types.INVOICE_ERROR_STATUS, false);
  Flowit.invoices
    .location(params)
    .then(response => {
      commit(types.LOCATION, response.data.location);
      commit(types.NEW_INVOICE_STATUS, true);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {
      commit(types.INVOICE_ERROR_STATUS, true);
      commit(types.INVOICE_ERROR_MESSAGE, error);
      commit(types.LOADING_DATA, false);
    });
};

// Eletronic Receipts
export const loadEletronicReceipts = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  Flowit.invoices.listEletronicReceipts(params).then(response => {
    commit(types.SET_ELETRONIC_RECEIPTS_RESOURCES, response.data.receipts);
    commit(types.SET_ELETRONIC_RECEIPTS_RESOURCES_COUNT, response.data.count);
    commit(types.SET_ELETRONIC_RECEIPTS_LOADING_DATA, false);
  });
};

export const setEletronicReceiptsCurrentPage = ({ commit }, page) => {
  commit(types.SET_ELETRONIC_RECEIPTS_CURRENT_PAGE, page);
};

export const setEletronicReceiptsLimit = ({ commit }, limit) => {
  commit(types.SET_ELETRONIC_RECEIPTS_LIMIT, limit);
};

export const cancelEletronicReceipt = ({ commit }, id) => {
  Flowit.invoices
    .cancelEletronicReceipt(id)
    .then(response => {})
    .catch(error => {});
};

export const eletronicReceipt = ({ commit }, id) => {
  Flowit.invoices
    .eletronicReceipt(id)
    .then(response => {
      commit(types.ELETRONIC_RECEIPT, response.data.receipt);
    })
    .catch(error => {});
};

export const newEletronicReceipt = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  commit(types.NEW_INVOICE_STATUS, false);
  commit(types.INVOICE_ERROR_STATUS, false);
  Flowit.invoices
    .newEletronicReceipt(params)
    .then(response => {
      commit(types.NEW_ELETRONIC_RECEIPT, response.data.receipt);
      commit(types.NEW_INVOICE_STATUS, true);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {
      // console.log(error);
      commit(types.INVOICE_ERROR_STATUS, true);
      commit(types.INVOICE_ERROR_MESSAGE, error);
      commit(types.LOADING_DATA, false);
    });
};
